import { useSearchParams } from 'react-router';
import { Input } from '../ui/input';
import { Params } from '@/utils/types';

type TableFilterProps = {
	handleFilterChange: (value: string) => void;
};

export const TableFilter = ({ handleFilterChange }: TableFilterProps) => {
	const [searchParams] = useSearchParams();
	return (
		<Input
			placeholder="Search..."
			defaultValue={searchParams.get(Params.search) || ''}
			onChange={event => handleFilterChange(event.target.value)}
			className="max-w-sm"
			aria-label="Search"
		/>
	);
};
